import { ILoadable } from '../interfaces';

export interface LoadingPropertyDescriptor extends PropertyDescriptor {
	value?: (...params: any[]) => Promise<any>;
}

export function loading(
	target: ILoadable,
	propertyKey: string,
	descriptor: LoadingPropertyDescriptor
) {
	let func = descriptor.value;
	descriptor.value = function(...params: any[]): Promise<any> {
		var _self = this;
		if (isILoadable(_self)) {
			_self.loading(true);
			return new Promise((resolve, reject) => {
				func
					.apply(_self, params)
					.then(resolve, reject)
					.then(() => {
						_self.loading(false);
					});
			});
		} else {
			throw new Error('Bad usage of decorator');
		}
	};
	return descriptor;
}

export function isILoadable(loadable: ILoadable): loadable is ILoadable {
	return (<ILoadable>loadable).loading !== undefined;
}
